import {create} from 'zustand';
import {persist, createJSONStorage} from 'zustand/middleware';

export const usePopupAnnouncementStore = create(
  persist(
    set => ({
      popupAnnouncement: {},
      step: 0,
      setStep: step => set({step}),
      setPopupAnnouncement: popupAnnouncement =>
        set({popupAnnouncement: {...popupAnnouncement}}),
      clearPopupAnnouncement: () => set({popupAnnouncement: {}}),
    }),
    {
      name: 'popupAnnouncement',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export const useReferralPartnerStore = create(
  persist(
    set => ({
      partnerName: '',
      partnerEmail: '',
      setPartnerInfo: (name, email) =>
        set({partnerName: name, partnerEmail: email}),
      clearPartnerInfo: () => set({partnerName: '', partnerEmail: ''}),
    }),
    {
      name: 'referralPartner',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export const useSimModeStore = create(
  persist(
    set => ({
      isSimMode: false,
      canUseSimMode: false,
      toggleSimMode: () => set(state => ({isSimMode: !state.isSimMode})),
      setSimMode: mode => set({isSimMode: mode}),
      setCanUseSimMode: canUse => set({canUseSimMode: canUse}),
    }),
    {
      name: 'simMode',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
